import Loadable from 'react-loadable'

const FilmFest = Loadable({
    loader: () => import(/* webpackChunkName: "filmFest" */ './film-fest'),
    loading: () => null,
})

const FilmFestRoute = () => <FilmFest />

export default FilmFestRoute
